"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WWReportTypes = void 0;
exports.getWWReportTypes = getWWReportTypes;
exports.getWWReportTypesFrom = getWWReportTypesFrom;
var WWReportTypes;
(function (WWReportTypes) {
    WWReportTypes["Compile"] = "Compile";
    WWReportTypes["Compare"] = "Compare";
})(WWReportTypes || (exports.WWReportTypes = WWReportTypes = {}));
function getWWReportTypes() {
    return [WWReportTypes.Compile, WWReportTypes.Compare];
}
function getWWReportTypesFrom(value) {
    return getWWReportTypes().find(function (type) { return type === value; });
}
